import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "app-root" };
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppLayout from '@/components/AppLayout.vue';
import PosLayout from '@/components/PosLayout.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const route = useRoute();
        const layout = computed(() => route.meta.layout || 'default');
        return (_ctx, _cache) => {
            const _component_RouterView = _resolveComponent("RouterView");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (layout.value === 'blank')
                    ? (_openBlock(), _createBlock(_component_RouterView, { key: 0 }))
                    : (layout.value === 'home')
                        ? (_openBlock(), _createBlock(_component_RouterView, { key: 1 }))
                        : _createCommentVNode("", true),
                (layout.value === 'app' || layout.value === 'default')
                    ? (_openBlock(), _createBlock(AppLayout, { key: 2 }, {
                        default: _withCtx(() => [
                            _createVNode(_component_RouterView)
                        ]),
                        _: 1
                    }))
                    : (layout.value === 'pos')
                        ? (_openBlock(), _createBlock(PosLayout, { key: 3 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_RouterView)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
